import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

export default function Sidebar({
  setOpacity = () => {},
  links = [],
  currentContent = "loreal",
  setCurrentContent = () => {},
}) {
  const [isOpen, setIsOpen] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth >= 961 : true
  );
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth < 961 : false
  );

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 961;
      setIsMobile(mobile);
      setIsOpen(!mobile);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const selectProject = (href) => {
    if (href === currentContent) {
      if (isMobile) setIsOpen(false);
      return;
    }
    if (isMobile) setIsOpen(false);
    setOpacity(0);
    setTimeout(() => {
      setCurrentContent(href);
      setOpacity(1);
    }, 180);
  };

  return (
    <div className="sidebar-shell">
      <button
        type="button"
        className="sidebar-toggle"
        aria-label={isOpen ? "Fermer le menu" : "Ouvrir le menu"}
        onClick={() => setIsOpen((open) => !open)}
      >
        {isOpen ? <X size={22} /> : <Menu size={22} />}
      </button>

      <AnimatePresence>
        {isMobile && isOpen && (
          <motion.div
            className="sidebar-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setIsOpen(false)}
          />
        )}
      </AnimatePresence>

      <motion.aside
        className="sidebar"
        initial={false}
        animate={{ x: isOpen || !isMobile ? 0 : "-105%" }}
        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
      >
        <div className="sidebar-brand">
          <img
            className="sidebar-avatar"
            src="./assets/pp.jpeg"
            alt="Julien Jacobs"
          />
          <div>
            <h1 className="sidebar-name">Julien Jacobs</h1>
            <p className="sidebar-role">Expériences interactives</p>
          </div>
        </div>

        <nav className="sidebar-nav" aria-label="Projets">
          <ul>
            {links.map((link) => (
              <li key={link.href}>
                <div
                  role="button"
                  tabIndex={0}
                  onClick={() => selectProject(link.href)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      selectProject(link.href);
                    }
                  }}
                  className={`sidebar-link${
                    link.href === currentContent ? " is-active" : ""
                  }`}
                >
                  {link.name}
                </div>
              </li>
            ))}
          </ul>
        </nav>

        <div className="sidebar-contact">
          <a href="mailto:julien.j.1999@hotmail.com">
            julien.j.1999@hotmail.com
          </a>
        </div>
      </motion.aside>
    </div>
  );
}
